export default {
	addPerson: "Ajouter une personne",
	confirmRemovePerson: "Êtes-vous sûr de vouloir supprimer cette personne ?",
	editPerson: "Modifier la personne",
	errorActivatingPerson: "Erreur lors de l'activation de la personne",
	errorDeactivatingPerson: "Erreur lors de la désactivation de la personne",
	errorLoadingAvailablePersons: "Erreur lors du chargement des personnes disponibles",
	errorLoadingPersons: "Erreur lors du chargement des personnes",
	errorRemovingPerson: "Erreur lors de la suppression de la personne",
	errorSavingPerson: "Erreur lors de l'enregistrement de la personne",
	person: "Personne",
	personActivatedSuccess: "Personne activée avec succès",
	personAddedSuccess: "Personne ajoutée avec succès",
	personDeactivatedSuccess: "Personne désactivée avec succès",
	personRemovedSuccess: "Personne supprimée avec succès",
	personUpdatedSuccess: "Personne mise à jour avec succès",
};
